module.exports = __webpack_public_path__ + "r-v3/img/menu_ai_meeting_note_on.fadcc135.svg";